import { SET_DEVICES, REMOVE_DEVICE_SUCCESS, RESET_DEVICES } from './types';

const initialState = {
  devices: [],
  isFetched: false
};

export default function(state = initialState, { type, payload }) {
  switch (type) {
    case SET_DEVICES: {
      return {
        ...state,
        devices: (payload.devices || []).filter(device => !device.isDeleted),
        isFetched: true
      };
    }

    case REMOVE_DEVICE_SUCCESS: {
      return {
        ...state,
        devices: state.devices.filter(device => device.id !== payload.id)
      };
    }

    case RESET_DEVICES: {
      return {
        devices: [],
        isFetched: false
      };
    }

    default: {
      return state;
    }
  }
}
